












































































































































































































































































































































































import Component, {mixins} from 'vue-class-component';
import {postAd} from '@/clients/UserAdsClient';
import FormErrorsMixin from '@/mixins/FormErrorsMixin.vue';
import {fileTypeRule, requiredRule} from '@/utils/ValidationRules';
import {ValidationInstruction} from '@/types/FormErrors';
import VueRecaptcha from 'vue-recaptcha';
import {VueGtag} from 'vue-gtag';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';

interface AdForm extends Record<string, string|number|File|undefined>{
  login?: string;
  name?: string;
  age?: number;
  sex?: string;
  location?: string;
  aboutMe?: string;
  interests?: string;
  appearance?: string;
  expectations?: string;
  perfectDate?: string;
  habits?: string;
  other?: string;
  photo?: File;
  recaptchaResponse?: string;
}

@Component({
  name: 'NewAdForm',
  components: {VueRecaptcha},
})
export default class NewAdForm extends mixins(FormErrorsMixin) {
  private adForm: AdForm = {};
  private inProgress = false;
  private recaptchaSitekey: string = process.env.VUE_APP_SITE_KEY;
  private validationInstructions: Array<ValidationInstruction> = [
    {field: 'login', rules: [requiredRule]},
    {field: 'name', rules: [requiredRule]},
    {field: 'age', rules: [requiredRule]},
    {field: 'sex', rules: [requiredRule]},
    {field: 'location', rules: [requiredRule]},
    {field: 'aboutMe', rules: [requiredRule]},
    {field: 'interests', rules: [requiredRule]},
    {field: 'appearance', rules: [requiredRule]},
    {field: 'expectations', rules: [requiredRule]},
    {field: 'perfectDate', rules: [requiredRule]},
    {field: 'habits', rules: [requiredRule]},
    {field: 'photo', rules: [requiredRule, fileTypeRule]},
  ];

  private onSubmit() {
    let success = false;
    this.getFormErrors<AdForm>(this.validationInstructions, this.adForm);
    if (!this.validateFields()) {
      this.$bvModal.msgBoxOk('Wszystkie pola z wyjątkiem dodatkowych informacji są wymagane.');
      this.resetRecaptcha();
      this.trackSubmitEvent({success});
      return;
    }
    if (!this.validatePhoto()) {
      this.$bvModal.msgBoxOk('Załącz zdjęcie w formacie JPG, PNG lub GIF.');
      this.resetRecaptcha();
      this.trackSubmitEvent({success});
      return;
    }

    this.inProgress = true;
    postAd({
      ...this.adForm,
      age: this.adForm.age?.toString(),
    })
      .then(response => {
        if (response.ok) {
          success = true;
          this.formErrors = [];
          this.adForm = {};
          this.$bvModal.msgBoxOk('Wkrótce dostaniesz link do potwierdzenia zgłoszenia.', {
            title: 'Zgłoszenie wysłane',
          });
        } else {
          this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + response.statusText, {
            title: 'Błąd',
          });
        }
      })
      .catch(err => {
        this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + err);
      })
      .finally(() => {
        this.inProgress = false;
        this.resetRecaptcha();
        this.trackSubmitEvent({success});
      });
  }

  private validateFields(): boolean {
    return this.adForm.login !== undefined && this.adForm.login.trim().length > 0 &&
            this.adForm.name !== undefined && this.adForm.name.trim().length > 0 &&
            this.adForm.age !== undefined &&
            this.adForm.sex !== undefined &&
            this.adForm.location !== undefined && this.adForm.location.trim().length > 0 &&
            this.adForm.aboutMe !== undefined && this.adForm.aboutMe.trim().length > 0 &&
            this.adForm.interests !== undefined && this.adForm.interests.trim().length > 0 &&
            this.adForm.appearance !== undefined && this.adForm.appearance.trim().length > 0 &&
            this.adForm.expectations !== undefined && this.adForm.expectations.trim().length > 0 &&
            this.adForm.perfectDate !== undefined && this.adForm.perfectDate.trim().length > 0 && 
            this.adForm.habits !== undefined && this.adForm.habits.trim().length > 0;
  }

  private validatePhoto(): boolean {
    return this.adForm.photo !== undefined &&
            (this.adForm.photo.type === 'image/jpeg' ||
            this.adForm.photo.type === 'image/png' ||
            this.adForm.photo.type === 'image/gif');
  }

  private trackSubmitEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('submit', eventParams);
    }
  }

  private onRecaptchaVerify(response: string): void {
    this.adForm.recaptchaResponse = response;
  }

  private resetRecaptcha(): void {
    (this.$refs.recaptcha as VueRecaptcha).reset();
    this.adForm.recaptchaResponse = undefined;
  }
}
